import { createSlice } from "@reduxjs/toolkit";

export const defaultFormulation = {
  colourName: "",
  colourCode: "",
  date: "",
  basePricePerKg: "",
  lossPercent: 2,
  labourCost: 30,
  benefitPercent: 25,
  finalPricePerKg: "",
  materials: [],
  _id: "",
};

const formulationSlice = createSlice({
  name: "formulation",
  initialState: {
    list: [],
    selected: defaultFormulation,
    refreshNeeded: false,
  },
  reducers: {
    addFormulation: (state, action) => {
      state.list = action.payload;
    },
    addSingleFormulation: (state, action) => {
      state.selected = { ...defaultFormulation, ...action.payload }; // ✅ merge to avoid missing fields
    },
    triggerRefresh: (state) => {
      state.refreshNeeded = true;
    },
    clearRefresh: (state) => {
      state.refreshNeeded = false;
    },
  },
});

export const {
  addFormulation,
  addSingleFormulation,
  triggerRefresh,
  clearRefresh,
} = formulationSlice.actions;

export default formulationSlice.reducer;
